import { render, staticRenderFns } from "./TemplatesStatusControl.vue?vue&type=template&id=9c899c38&scoped=true"
import script from "./TemplatesStatusControl.vue?vue&type=script&lang=js"
export * from "./TemplatesStatusControl.vue?vue&type=script&lang=js"
import style0 from "./TemplatesStatusControl.vue?vue&type=style&index=0&id=9c899c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c899c38",
  null
  
)

export default component.exports